<template>
  <div class="job-applicant-profile learner_profile">

    <div class="card crd_sty_3 contact-card">
      <div class="row pg_sec_head">
        <div class="col-10">
          <div class="hd_txt">Contact Information</div>
        </div>
      </div>
      <div class="row section_row">
        <div class="col-12 section_content">
          <div class="row">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col">
                <div class="row">
                  <div class="col-12 col_txt_row">
                    <span class="title">Email : {{userObject.eMail}}</span>
                  </div>
                  <div class="col-12 col_txt_row">
                    <span class="title">Phone : {{userObject.primaryPhoneNumber}}</span>
                  </div>
                  <div class="col-12 col_txt_row" v-if="userObject.city">
                    <span class="title">{{ $t('city') }} : {{ userObject.city }}</span>
                  </div>
                  <div class="col-12 col_txt_row" v-if="userObject.state">
                    <span class="title">{{ $t('state') }} : {{ userObject.state }}</span>
                  </div>
                  <div class="col-12 col_txt_row" v-if="userObject.linkedIn">
                    <span class="title">
                      {{ $t('linkedin') }} :
                      <b-link :href="linkedInHref" :title="userObject.linkedIn" target="_blank">{{ userObject.linkedIn }}</b-link>
                    </span>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card crd_sty_3" v-if="resume && resume.uploadedVersions">
      <div class="row pg_sec_head">
        <div class="col-10">
          <div class="hd_txt">{{ $t('resume') }}</div>
        </div>
      </div>
      <div class="row section_row">
        <div class="col-12 section_content">
          <div class="row">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col">
                <div class="row">
                <template v-for="version in resume.uploadedVersions">
                  <div class="col-12 col_txt_row hd" v-if="version.primary" >
                    <span  class="title" @click="download(version)" >{{version.fileName}}</span>
                    <button  
                  class="btn btn_ic" 
                  @click="download(version)"
                  :aria-label="$t('downloadResumeAria')"
                  :title="$t('downloadResumeTitle')"
                  v-b-tooltip.hover>
                    <span class="fa fa-download" aria-hidden="true"></span>
                    </button>
                  </div>
                </template>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>


    <div class="card crd_sty_3" v-if="experienceList.length > 0">
      <div class="row pg_sec_head">
        <div class="col-10">
          <div class="hd_txt">{{ $t('experience') }}</div>
        </div>
      </div>
      <div class="row section_row">
        <div class="col-12 section_content">
          <template v-if="experienceList.length > 0">
            <div class="row">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col profile-entry"
                v-for="(experience, index) in experienceList"
                :key="'experience-' + index">
                <div class="row">
                  <div class="col-12 col_txt_row hd" v-if="experience.title">
                    <span class="title">{{ $t('title') }}: {{ experience.title }}</span>
                  </div>
                  <div class="col-12 col_txt_row" v-if="experience.description">
                    {{ $t('description') }}: {{ experience.description }}
                  </div>
                  <div class="col-12 col_txt_row" v-if="experience.employer">
                    {{ $t('employer') }}: {{ experience.employer }}
                  </div>
                  <div class="col-12 col_txt_row" v-if="experience.industry">
                    {{ $t('industry') }}: {{ experience.industry }}
                  </div>
                  <div class="col-12 col_txt_row" v-if="experience.location">
                    {{ $t('location') }}: {{ experience.location }}
                  </div>
                  <div class="col-12 col_txt_row" v-if="experience.experienceTimeLabel">
                    {{ $t('duration') }}: {{ experience.experienceTimeLabel }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="card crd_sty_3" v-if="educationList.length > 0" >
      <div class="row pg_sec_head">
        <div class="col-10">
          <div class="hd_txt">{{ $t('education') }}</div>
        </div>
      </div>
      <div class="row section_row">
        <div class="col-12 section_content">
          <template v-if="educationList.length > 0">
            <div class="row">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col profile-entry"
                v-for="(education, index) in educationList"
                :key="'education-' + index">
                <div class="row">
                  <div class="col-12 col_txt_row hd">
                    <span class="title">
                      <template v-if="education.degree">{{ $t('degree') }}: {{ education.degree }}</template>
                      <template v-if="education.classOf">, Class of {{ education.classOf }}</template>
                    </span>
                  </div>
                  <div class="col-12 col_txt_row" v-if="education.institution">
                    {{ $t('institution') }}: {{ education.institution }}
                  </div>
                  <div class="col-12 col_txt_row" v-if="education.majorOne">Major: {{ education.majorOne }}</div>
                  <div class="col-12 col_txt_row" v-if="education.majorTwo">Major: {{ education.majorTwo }}</div>
                  <div class="col-12 col_txt_row" v-if="education.educationTimeLabel">Duration: {{ education.educationTimeLabel }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div class="card crd_sty_3" v-if="applicantEnrollments.length > 0" >
      <div class="row pg_sec_head">
        <div class="col-10">
          <div class="hd_txt">Certificates</div>
        </div>
      </div>
      <div class="row section_row">
        <div class="col-12 section_content">
          <template v-if="applicantEnrollments.length > 0">
            <div class="row">
              <div
                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col"
                v-for="(enrollment, index) in applicantEnrollments"
                :key="'enrollment-' + index">
                <div class="row">
                  <div class="col-12 col_txt_row hd">
                    <span class="title">
                      <template v-if="enrollment.programTitle">{{ enrollment.programTitle }}</template>
                    </span>
                  </div>
                  <div class="col-12 col_txt_row" v-if="enrollment.status">
                    {{ $t('status') }}: {{ enrollment.status.toLowerCase() }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'jobApplicantProfile',
    props: {
      applicantId: {
        type: String,
        default: ''
      }
    },
    data: () => {
      return {
        monthMap: {
          0: 'January',
          1: 'February',
          2: 'March',
          3: 'April',
          4: 'May',
          5: 'June',
          6: 'July',
          7: 'August',
          8: 'September',
          9: 'October',
          10: 'November',
          11: 'December'
        }
      }
    },
    computed: {
      ...mapState({
        userObject: state => state.job.userObject,
        applicantEnrollmentData: state => state.job.applicantEnrollment
      }),
      formattedPerson () {
        let profile = (this.userObject && this.userObject.userProfile) || {}
        return {
          experienceInfoList: (profile.experienceInfoList || []).map((experience) => {
            return Object.assign({}, experience, {
              experienceTimeLabel: this.buildTimeRangeLabel(experience.from, experience.to)
            })
          }),
          educationInfoList: (profile.educationInfoList || []).map((education) => {
            return Object.assign({}, education, {
              educationTimeLabel: this.buildTimeRangeLabel(education.from, education.to)
            })
          })
        }
      },
      applicantEnrollments () {
        return this.applicantEnrollmentData || []
      },
      experienceList () {
        return (this.formattedPerson && this.formattedPerson.experienceInfoList) || []
      },
      resume () {
        if(this.userObject && this.userObject.userProfile){
          return (this.userObject.userProfile.resume)
        }
        return {}
      },
      educationList () {
        return (this.formattedPerson && this.formattedPerson.educationInfoList) || []
      },
      linkedInHref () {
        let url = (this.userObject && this.userObject.linkedIn) || ''
        if (!url) {
          return ''
        }
        if (/^https?:\/\//i.test(url)) {
          return url
        }
        return 'https://' + url
      }
    },
    watch: {
      applicantId: {
        immediate: true,
        handler (applicantId) {
          this.loadJobApplicantEnrollmentData(applicantId)
          this.loadApplicantProfile(applicantId)
        }
      }
    },
    methods: {
      ...mapActions([
        'loadJobApplicantUser',
        'loadApplicantEnrollmentData'
      ]),
      loadApplicantProfile (applicantId) {
        if (!applicantId) {
          this.loadJobApplicantUser('')
          return
        }
        this.loadJobApplicantUser(applicantId)
      },
      loadJobApplicantEnrollmentData (applicantId) { 
        this.loadApplicantEnrollmentData(applicantId)
      },
      download (currentVersion) {
        let path = currentVersion.fileUrl
        let filename = currentVersion.fileName
        const anchor = document.createElement('a')
        anchor.href = path
        anchor.download = filename
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
      },

      buildTimeRangeLabel (from, to) {
        if (!from) {
          return ''
        }
        let monthMap = this.monthMap
        let dateTime = new Date(from)
        let label = monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear() + ' - '
        if (to && !(to instanceof Date)) {
          dateTime = new Date(to)
          label += monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear()
        } else if (to && to instanceof Date && !isNaN(to.getMonth())) {
          dateTime = to
          label += monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear()
        } else {
          label += 'Present'
        }
        return label
      }
    }
  }
</script>

<style scoped>
  .job-applicant-profile {
    padding: 8px 8px 24px;
  }

  .job-applicant-profile ::v-deep .card.crd_sty_3 {
    margin: 0px 0 16px;
  }
  .card.crd_sty_3 {
    margin: 0px 15px 30Px;
  }
  .job-applicant-profile ::v-deep .card.crd_sty_3 .pg_sec_head {
    margin-bottom: 4px;
  }

  .job-applicant-profile ::v-deep .card.crd_sty_3 .section_content {
    padding-bottom: 8px;
  }

  .job-applicant-profile ::v-deep .card.crd_sty_3 .sec_col {
    border-bottom: none !important;
  }

  .job-applicant-profile ::v-deep .card.crd_sty_3 .sec_col:not(.profile-entry) {
    padding-top: 5px;
    padding-bottom: 0;
  }

  .job-applicant-profile ::v-deep .card.crd_sty_3 .col_txt_row:last-child {
    margin-bottom: 0;
  }

  .job-applicant-profile .learner_profile .section_content .sec_col.profile-entry {
    margin-top: 0;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 25px !important;
    padding-top: 12px;
    padding-bottom: 16px !important;
    border-bottom: none !important;
  }

  .job-applicant-profile.learner_profile .section_content .sec_col.profile-entry:first-child {
    padding-top: 5px;
  }

  .job-applicant-profile.learner_profile .section_content .sec_col.profile-entry:last-child {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/job/components/JobApplicantProfile.vue